"use client";

import React, { useEffect, useMemo, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Navbar from "../../../../../components/navbar";
import Footer from "../../../../../components/footer";
import Button from "../../../../../components/Button";
import Table from "../../../../../components/Table";
import Pagination from "../../../../../components/Pagination";
import { Search } from "lucide-react";
import styles from "../../Credit/css/creditProfiles.module.css";

const MOCK_PROFILES = [
  {
    profileNumber: "639000",
    surname: "Morris",
    initial: "T",
    title: "Mrs",
    address: "189 Oak Lane",
  },
  {
    profileNumber: "796000",
    surname: "Morris",
    initial: "L",
    title: "Mr",
    address: "4 Park Road",
  },
  {
    profileNumber: "945000",
    surname: "Taylor",
    initial: "M",
    title: "Ms",
    address: "89 Samson Street",
  },
  {
    profileNumber: "180000",
    surname: "Fernandez",
    initial: "B",
    title: "Miss",
    address: "21 Blundall Road",
  },
];

export default function SplitMedicalAidProfilesView() {
  const location = useLocation();
  const navigate = useNavigate();
  const [search, setSearch] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [total, setTotal] = useState(0);
  const pageSize = 5;
  const fromDebtors = !!(location.state && location.state.fromDebtors);

  const handleBack = () => {
    navigate("/frontshop/payment-types/split", {
      state: { total, fromDebtors },
    });
  };

  useEffect(() => {
    if (location.state && typeof location.state.total === "number") {
      setTotal(location.state.total);
      return;
    }

    try {
      const raw = localStorage.getItem("frontshop_basket");
      if (raw) {
        const parsed = JSON.parse(raw);
        if (Array.isArray(parsed)) {
          const subtotal = parsed.reduce(
            (sum, item) => sum + (Number(item.price) || 0) * (Number(item.qty) || 0),
            0
          );
          const tax = subtotal * 0.15;
          setTotal(subtotal + tax);
        }
      }
    } catch {
      // ignore storage parse errors
    }
  }, [location.state]);

  const filteredProfiles = useMemo(() => {
    const q = search.trim().toLowerCase();
    if (!q) return MOCK_PROFILES;
    return MOCK_PROFILES.filter((row) =>
      `${row.profileNumber} ${row.surname} ${row.address}`.toLowerCase().includes(q)
    );
  }, [search]);

  const totalPages = Math.max(1, Math.ceil(filteredProfiles.length / pageSize));

  const pageData = useMemo(() => {
    const start = (currentPage - 1) * pageSize;
    return filteredProfiles.slice(start, start + pageSize);
  }, [filteredProfiles, currentPage]);

  useEffect(() => {
    setCurrentPage(1);
  }, [search]);

  useEffect(() => {
    if (currentPage > totalPages) setCurrentPage(totalPages);
  }, [totalPages, currentPage]);

  const handleSelect = (row) => {
    navigate("/frontshop/payment-types/split/medical-aid/payment", {
      state: { total, profileNumber: row.profileNumber, fromDebtors },
    });
  };

  const columns = [
    { header: "Profile Number", accessor: "profileNumber" },
    { header: "Surname", accessor: "surname" },
    { header: "Initial", accessor: "initial" },
    { header: "Title", accessor: "title" },
    { header: "Address", accessor: "address" },
    {
      header: "Action",
      accessor: "action",
      render: (_, row) => (
        <Button
          type="button"
          variant="primary"
          className={styles.actionButton}
          onClick={() => handleSelect(row)}
        >
          Select
        </Button>
      ),
    },
  ];

  return (
    <div className={styles.wrapper}>
      <Navbar onBack={handleBack} />

      <main className={styles.main}>
        <div className={styles.container}>
          <div className={styles.filterCard}>
            <span className={styles.filterLabel}>Filter</span>
            <div className={styles.searchWrapper}>
              <Search size={16} className={styles.searchIcon} />
              <input
                className={styles.searchInput}
                placeholder="Search"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
              />
            </div>
          </div>

          <section className={styles.tableSection}>
            <Table columns={columns} data={pageData} />

            {totalPages > 1 && (
              <div className={styles.paginationWrap}>
                <Pagination
                  currentPage={currentPage}
                  totalPages={totalPages}
                  onPageChange={setCurrentPage}
                />
              </div>
            )}
          </section>
        </div>
      </main>

      <div className={styles.footerWrapper}>
        <Footer />
      </div>
    </div>
  );
}
